import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';
import { ERROR_ACCOUNT_NOT_EXIST, ERROR_RECORD_NOT_FOUND } from '@/utils/errorCodeList';
import { numberInputHandler } from '@/utils/helper';
import {
  account as accountRule,
  identification as identificationRule,
  required,
} from '@/utils/validators';

export default {
  name: 'ForgetPassword',
  props: {
    open: {
      default: false,
      type: Boolean,
    },
  },
  setup() {
    return { forgetPwdValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      form: {
        account: '',
        identification: '',
      },
      hasIdentificationParam: false,
    };
  },
  computed: {
    ...mapState('user', {
      sending: ({ sendingForgetPwdLink }) => sendingForgetPwdLink,
    }),
  },
  mounted() {
    this.fillValues();
  },
  methods: {
    ...mapActions('user', {
      sendForgetPwdLink: 'SEND_FORGET_PASSWORD_LINK',
    }),
    async fillValues() {
      const {
        identification: id = '',
      } = this.$route?.query || {};

      const identification = decodeURIComponent(id);
      this.form.identification = Number(identification);
      const valid = await this.forgetPwdValidator$.form.identification.$validate(identification);

      this.forgetPwdValidator$.form.identification.$dirty = false;
      this.hasIdentificationParam = valid;
      this.form.identification = valid ? Number(identification) : '';
    },
    async send() {
      const valid = await this.forgetPwdValidator$.$validate();
      if (!valid) return;

      try {
        await this.sendForgetPwdLink(this.form);
        this.$snackbar({
          type: SNACKBAR_TYPES.SUCCESS,
          msg: '已寄送Email通知管理員。',
        });
        this.close();
      } catch (error) {
        const { message = '', status } = error;
        const errors = [ERROR_ACCOUNT_NOT_EXIST, ERROR_RECORD_NOT_FOUND];
        const msg = errors.includes(status)
          ? '查無此帳號，請檢查統一編號和帳號是否正確。' : `傳送失敗，請稍後再試。${message}`;
        this.$snackbar({ type: SNACKBAR_TYPES.ERROR, msg });
      }
    },
    close() {
      this.form.account = '';
      this.form.identification = '';
      this.forgetPwdValidator$.form.account.$reset();
      this.forgetPwdValidator$.form.identification.$reset();
      this.$emit('close');
    },
    getErrorMsgs(field) {
      return this.forgetPwdValidator$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return !!this.forgetPwdValidator$.form?.[field]?.$errors?.length;
    },
    onNumberInputKeydown(event) {
      numberInputHandler(event);
    },
  },
  validations() {
    return {
      form: {
        account: { required: required('帳號'), accountRule },
        identification: { required: required('統一編號'), identificationRule },
      },
    };
  },
};
